<div class="popupbg">
    <div class="popupcont">
        <div class="basicrow f-black f-mildt roboto-m lineBrd">
            Actualiza tu Perfil
        </div>   
        <div class="basicrow m-top-i">
            <label class="label-r">&#42; Escoge pasatiempo favorito</label>
            <div class="basicrow">
                <select class="sel-f" [(ngModel)]="this.pasatiempoSelect">
                    <option [ngValue]="null">Seleccionar</option>
                    <option *ngFor="let valor of this.pasatiempos; let i = index" [ngValue]="valor">{{valor}}</option>
                </select>
            </div>
        </div>
        <div class="basicrow">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="basicrow m-top-i">
                        <label class="label-f">&#42; Fecha de Nacimiento</label>
                        <div class="basicrow rel">
                            <div class="datepicker_update inp-f qt">
                                <mat-form-field class="boxCont">
                                    <input matInput [matDatepicker]="myDatepicker" [(ngModel)]="this.birthdate">
                                    <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #myDatepicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <!--
                                <input [(ngModel)]="this.birthdate" class="datepicker_update inp-f qt">
                                <i class="fa fa-calendar inpcal-icon" aria-hidden="true"> </i>
                            -->
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="basicrow m-top-i">
                        <label class="label-f">&#42; E-mail de Factura Electr&oacute;nica</label>
                        <div class="basicrow">
                            <input style="color:gray;" class="inp-f" [(ngModel)]="this.emailClient" disabled="disabled">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="this.paperlessDisable!==false" class="basicrow f-reg f-black roboto-r m-top-i text-justify">
            <img class="plessicon" width="100%" src="../../../assets/images/fact-dig.png">
            <div class="caja-opciones">
                <div class="popopt less-m roboto-b">
                    Paperless:
                </div>
                <div>
                    <div class="popopt less-m num1">
                        <input name="paperless" value="true" type="radio" [checked]="this.paperless"
                            (click)="this.setPaperless(true)"> Sí
                    </div>
                    <div class="popopt less-m num2">
                        <input name="paperless" value="false" type="radio" [checked]="(this.paperless==false)"
                            (click)="this.setPaperless(false)"> No
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow text-center m-top">
            <a (click)="this.updateAccount();" id="btnUpdateAccount"
                [ngClass]="{'btns':true, 'def-i':true, 'pull-right':true, 'vcenter':true, 'red': (this.pasatiempoSelect!=null && this.paperless==true), 'gray': (this.pasatiempoSelect==null||!this.paperless)}">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right continue" aria-hidden="true"></i>
                </span>
            </a>
            <a (click)="this.close();" class="btns def-i gray pull-left vcenter spac">
                <span class="tabcell">
                    Cancelar
                </span>
            </a>
        </div>
    </div>
</div>